import {
  OriginContextPayload,
  OriginContextProduct,
} from "@adsk/acc-issues-types";
import { useMemo } from "react";
import { useHostingNames } from "@adsk/acc-issues-core/utils/hooks/useHostingNames";

/**
 * OriginContextPayload to send when our consumer does not provide one. If
 * the detected product is not in the list, don't provide a default.
 */
export function useDefaultOriginContextPayload():
  | OriginContextPayload
  | undefined {
  const { hostingModuleName: product, hostingTabName: tool } =
    useHostingNames();

  return useMemo(
    () =>
      Object.values(OriginContextProduct).includes(product)
        ? { product: product, tool }
        : undefined,
    [product, tool]
  );
}
